import type { Cover as CoverType, HelpText, Upsell } from "../../types";
import { Coverage as CoverageUK } from "./CoverageUK";
import { Coverage as Control } from "./Coverage";
import { variants } from "../../variants";

export type DisplayVariant = "qcp" | "qds";

export type CoverageProps = {
  helpText?: HelpText[];
  covers: CoverType[];
  additionalCoverage?: boolean;
  extraCovers?: CoverType[];
  className?: string;
  displayVariant: DisplayVariant;
  withModal?: boolean;
  variant?: string;
  upsells?: Upsell[];
};

export const Coverage = (props: CoverageProps) => {
  const { variant } = props;
  const isUKVariant = variants(variant);

  if (isUKVariant) {
    return <CoverageUK {...props} />;
  }

  return <Control {...props} />;
};
